import axios from "axios"
import Carttslice from "../store/Carttslice"

const addcartitem = (num,quantity) => async(dispatch) =>{
    try {
        dispatch(Carttslice.actions.carttrequest())
        const {data} = await axios.get(`https://retoolapi.dev/BUQ2aS/allcomponents/?num=${num}`)
        console.log(data)
        dispatch(Carttslice.actions.addtocartt({
           
            id : data[0].id,
            img: data[0].img,
            num:data[0].num,
            desc:data[0].desc,
            Price:data[0].price,
            stock:data[0].stock,
            title: data[0].title,
            quantity

        }))
        
    } catch (error) {
        console.log(error)
        
    }

}
export default addcartitem;